module.exports = __webpack_public_path__ + "media/images/icon-svg/logo-5d36db40724d3b65514fb3ae8b3f30d3.svg";